// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}\n._syazj3m3{color:var(--ds-text,#091e42)}", ""]);
// Exports
module.exports = exports;
